<template>
  <div class="expandable" :class="{'expandable--active': isOpen}">
    <button
      @click="toggleDropDown(0); toggleOpen()"
      :aria-expanded="isOpen"
      class="expandable__opener"
      type="button"
    >
      <slot name="title" />
      <span class="expandable__icon chevron-wrapper">
        <span class="chevron"></span>
      </span>
    </button>

    <div ref="content" :style="{ 'height': contentHeight + 'px' }" class="expandable__content">
      <div class="expandable__content-inner">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  animateContent_,
  setContent_, toggleDropdown_
} from "../../mixins";

export default {
  data() {
    return {
      isOpen: false,
      contentHeight: 0,
      animationProgress: 0,
      animationDuration: 200,
      dropdowns: [
        {isOpen: false},
      ],
    };
  },
  methods: {
    toggleOpen(){
      this.isOpen = !this.isOpen;
    }
  },
  mixins: [setContent_, animateContent_, toggleDropdown_],
  mounted() {},
};
</script>
